import { Spark } from "@/components/Spark";

type KpiProps = {
  label: string;
  value: string;
  unit?: "$" | "×" | "%" | null;
  delta?: string;
  deltaDir?: "pos" | "neg" | null;
  spark?: number[] | null;
};

/**
 * Overview KPI card. Large serif number, small unit flourish, delta
 * footer "▲ 12% vs prev period", miniature sparkline in the corner.
 *
 * Pass `value` pre-formatted (the caller owns digit / locale choices).
 * `unit` positions `$` as a prefix and `×`/`%` as a suffix.
 */
export function Kpi({ label, value, unit, delta, deltaDir, spark }: KpiProps) {
  const sparkColor =
    deltaDir === "pos"
      ? "var(--c-pos-500)"
      : deltaDir === "neg"
        ? "var(--c-neg-500)"
        : "var(--c-accent-500)";

  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">
        {unit === "$" && <small>$</small>}
        <span>{value}</span>
        {unit && unit !== "$" && <small>{unit}</small>}
      </div>
      <div className="kpi-foot">
        {delta !== undefined && deltaDir && (
          <>
            <span className={`delta ${deltaDir}`}>
              {deltaDir === "pos" ? "▲" : "▼"} {delta}
            </span>
            <span className="muted">vs prev period</span>
          </>
        )}
      </div>
      <div className="kpi-spark">
        <Spark data={spark ?? null} color={sparkColor} />
      </div>
    </div>
  );
}
